<template>
	<div id="PortabilityFormSent" class="col-12 col-tab-1">

		<div class="limit-width">
			<ui-dotlottie-loader  aspect="1:1" />
		</div>

		<div class="text-center">
			<h2>¡Solicitud de portabilidad completa!</h2>

			<p>
				Así de sencillo puedes formar parte de BlackFon®. 
				<br>
				Muy pronto contarás con tu número anterior en tu nuevo SIM o eSIM.
			</p>
		</div>
	</div>
</template>

<script>
import successCheckmark2Component from '../shared/success-checkmark-component-2.vue';
export default {
	components: {
		successCheckmark2Component
	}
}
</script>

<style lang="scss">
	@import '@/sass/utils/variables.scss';

	#PortabilityFormSent {
		color: white;
		display: flex;
		flex-flow: column;
		gap: 1em;
		justify-content: center;
		align-items: center;
		margin: 8em 0;
		.limit-width {
			flex: 1 0 320px;
			width: 320px;
		}
		p {
			color: inherit
		}
	}
</style>